export const emailSac = 'mailto:sac@medprevonline.com';

export const visualEmailSac = 'sac@medprevonline.com';

export const phoneProfessionalSac = '41 3003-5153';

export const phonePatientSac = '8006727250';

export const visualPhonePatientSac = '0800 672 7250';

export const medprevCnpj = '19.258.530/0001-62';
